<template>
  <div class="container">
    <!-- Reward Pools Section -->
    <div class="reward-pools">
      <input type="text" placeholder="Search..." v-model="searchTerm" />
      <button1 @click="sortPools">sort</button1>
      <ul>
        <li v-for="pool in filteredPools" :key="pool.id" @click="selectPool(pool)">
          <p>{{ pool.description }}</p>
          <p>{{ pool.creatorUser }}</p>
          <p>{{ pool.creationTransactionHash }}</p>
        </li>
      </ul>
    </div>

    <!-- Events Section -->
    <div class="events" v-if="selectedPool">
      <button1 @click="sortEvents">sort</button1>
      <ul>
        <li v-for="event in filteredEvents" :key="event.id" @click="selectEvent(event)">
          <p>{{ event.description }}</p>
          <p>{{ event.creatorUser }}</p>
          <p>{{ event.datetime }}</p>
        </li>
      </ul>
    </div>

    <!-- Event Details Section -->
    <div class="event-details" v-if="selectedEvent">
      <p>Details for event: {{ selectedEvent.description }}</p>
      <!-- More details here -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pools: [
        { id: 1, description: 'Pool #1', creatorUser: 'User A', creationTransactionHash: '0xABC' },
        { id: 2, description: 'Pool #2', creatorUser: 'User B', creationTransactionHash: '0xDEF' },
        { id: 3, description: 'Pool #3', creatorUser: 'User C', creationTransactionHash: '0xGHI' },
      ],
      events: [
        { id: 1, poolId: 1, description: 'Event 1', creatorUser: 'User A', datetime: '2024-04-07T12:00:00Z' },
        { id: 2, poolId: 1, description: 'Event 2', creatorUser: 'User A', datetime: '2024-04-08T15:00:00Z' },
        { id: 3, poolId: 2, description: 'Event 3', creatorUser: 'User B', datetime: '2024-04-09T18:30:00Z' },
      ],
      searchTerm: '',
      selectedPool: null,
      selectedEvent: null,
    };
  },
  computed: {
    filteredPools() {
      return this.pools.filter(pool =>
        pool.description.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
    filteredEvents() {
      return this.events.filter(event =>
        event.poolId === this.selectedPool.id
      );
    }
  },
  methods: {
    sortPools() {
      // Simple sort by description
      this.pools.sort((a, b) => a.description.localeCompare(b.description));
    },
    sortEvents() {
      // Simple sort by datetime
      this.events.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));
    },
    selectPool(pool) {
      this.selectedPool = pool;
      this.selectedEvent = null; // Clear selected event when a new pool is selected
    },
    selectEvent(event) {
      this.selectedEvent = event;
    }
  }
};
</script>

<style scoped>
/* Basic styles for layout */
.container {
  display: flex;
  justify-content: space-around;
}
.reward-pools, .events, .event-details {
  border: 1px solid #ddd;
  padding: 10px;
  margin: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  cursor: pointer;
  padding: 5px;
  margin: 5px;
  border: 1px solid #eee;
}
li:hover {
  background-color: #f0f0f0;
}
</style>
